/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_TransactionInputs */

const cs_public_site_demand_transaction = /** @type {(inputs: Public_Site_Demand_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const en_public_site_demand_transaction = /** @type {(inputs: Public_Site_Demand_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction`)
};

/**
* | output |
* | --- |
* | "Transaction" |
*
* @param {Public_Site_Demand_TransactionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_transaction = /** @type {((inputs?: Public_Site_Demand_TransactionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_TransactionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_transaction(inputs)
	return cs_public_site_demand_transaction(inputs)
});